import { createFileRoute, Outlet } from '@tanstack/react-router'

import type { TabItem } from '@/components/shell'
import { PhoneShell } from '@/components/shell'

/* Profil is NOT a tab — the avatar in the Přehled header is the door to it,
   the same pattern the client uses for the venue profile (owner, 2026-07-30). */
const SPRAVCE_TABS: TabItem[] = [
  { label: 'Přehled', href: '/spravce/prehled', icon: 'grid' },
  { label: 'Klienti', href: '/spravce/klienti', icon: 'utensils' },
  { label: 'Plány', href: '/spravce/plany', icon: 'calendar' },
  { label: 'Chaty', href: '/spravce/chaty', icon: 'comment' },
]

export const Route = createFileRoute('/spravce')({
  component: SpravceLayout,
})

function SpravceLayout() {
  return (
    <PhoneShell tabs={SPRAVCE_TABS}>
      <Outlet />
    </PhoneShell>
  )
}
